export default "__VITE_ASSET__BkYZlbxj__"